/*
 * App Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your application state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 */

import {
  INITIALIZE_SESSION_REQUEST,
  SESSION_INITIALIZED,
  SESSION_INITIALIZE_FAILED,
  LOGOUT_SESSION_REQUEST,
  LOAD_BOM_DATA,
  BOM_DATA_LOADED,
  BOM_DATA_ERROR,
  UPDATE_BOM_DATA,
  SUBMIT_BOM_DATA,
  BOM_DATA_SUBMITTED,
  BOM_SUBMIT_ERROR,
  CLEAR_UPLOADED_DATA,
  SET_LOADING,
  SET_ERROR,
  CLEAR_ERROR,
  SET_SUCCESS,
  CLEAR_SUCCESS,
} from './constants';

// Session actions
export function initializeSession() {
  return {
    type: INITIALIZE_SESSION_REQUEST,
  };
}

export function sessionInitialized(session) {
  return {
    type: SESSION_INITIALIZED,
    payload: session,
  };
}

export function sessionInitializeFailed(error) {
  return {
    type: SESSION_INITIALIZE_FAILED,
    error,
  };
}

export function logoutSessionRequest() {
  return {
    type: LOGOUT_SESSION_REQUEST,
  };
}

// BOM Data actions
export function loadBOMData(file) {
  return {
    type: LOAD_BOM_DATA,
    payload: file,
  };
}

export function bomDataLoaded(data) {
  return {
    type: BOM_DATA_LOADED,
    payload: data,
  };
}

export function bomDataError(error) {
  return {
    type: BOM_DATA_ERROR,
    error,
  };
}

export function updateBOMData(data) {
  return {
    type: UPDATE_BOM_DATA,
    payload: data,
  };
}

export function submitBOMData(data) {
  return {
    type: SUBMIT_BOM_DATA,
    payload: data,
  };
}

export function bomDataSubmitted(result) {
  return {
    type: BOM_DATA_SUBMITTED,
    payload: result,
  };
}

export function bomSubmitError(error) {
  return {
    type: BOM_SUBMIT_ERROR,
    error,
  };
}

export function clearUploadedData(successMessage = null) {
  return {
    type: CLEAR_UPLOADED_DATA,
    payload: successMessage,
  };
}

// UI state actions
export function setLoading(isLoading) {
  return {
    type: SET_LOADING,
    payload: isLoading,
  };
}

export function setError(error) {
  return {
    type: SET_ERROR,
    payload: error,
  };
}

export function clearError() {
  return {
    type: CLEAR_ERROR,
  };
}

export function setSuccess(message) {
  return {
    type: SET_SUCCESS,
    payload: message,
  };
}

export function clearSuccess() {
  return {
    type: CLEAR_SUCCESS,
  };
}
